import { render, staticRenderFns } from "./ImsProject.vue?vue&type=template&id=58359d06"
import script from "./ImsProject.vue?vue&type=script&lang=js"
export * from "./ImsProject.vue?vue&type=script&lang=js"
import style0 from "./ImsProject.vue?vue&type=style&index=0&id=58359d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports